import Joi from "joi";

export const companyNewSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  body: Joi.string().min(2).label("Body"),
  expirationDate: Joi.date().required().label("Expiration Date"),
});
